import _startCase from 'lodash/startCase';

import { SearchFacetWithAppliedTerms } from 'Src/types';

export const getTabIndex = (
  activeTab: number,
  isSelected: boolean,
  tabListIndex: number
): 0 | -1 => {
  const isFirstTab = tabListIndex === 0;
  if (activeTab) {
    // If there is an active tab, and
    // if the current tab is selected, it should be focusable via keyboard.
    // Other tabs will be focusable via the keydown handler on the list.
    return isSelected ? 0 : -1;
  } else {
    // If there is no active tab, and
    // if the current tab is the first tab in the list, it should be focusable via keyboard.
    // Other tabs will be focusable via the keydown handler on the list.
    return isFirstTab ? 0 : -1;
  }
};

/**
 * Check if the filter is a boolean field
 */
const isBooleanField = (filter: SearchFacetWithAppliedTerms): boolean => {
  return (
    filter &&
    Array.isArray(filter.appliedTerms) &&
    filter.appliedTerms[0]?.value === 'true'
  );
};

/**
 * Get the message for the filter chip
 */
export const getChipMessage = (filter: SearchFacetWithAppliedTerms) => {
  const applied = filter.appliedTerms?.length > 0;
  if (!applied || isBooleanField(filter)) {
    return {
      id: `field.name.${filter.field}`,
      defaultMessage: _startCase(filter.field),
      description: 'Chip label for boolean or unapplied filter'
    };
  }
  return {
    id: `field.value.${filter.field}.${filter.appliedTerms[0].value}`,
    defaultMessage: `${filter.appliedTerms[0].value}`,
    description: 'Chip label for applied filter'
  };
};
